var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5546_350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2066 11.9434H17.5156V32.0001H23.2066V11.9434Z",
    fill: "#F75B11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6675 20.8203H8.97656V32.0001H14.6675V20.8203Z",
    fill: "#F75B11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19098 27.104H0.5V31.9999H6.19098V27.104Z",
    fill: "#F75B11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1988 23.8042H17.5078V31.9998H23.1988V23.8042Z",
    fill: "#EF916C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6675 27.4321H8.97656V32H14.6675V27.4321Z",
    fill: "#EF916C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19098 30H0.5V32H6.19098V30Z",
    fill: "#EF916C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4984 6.84543H20.0213V3.43849H16.6016V0H23.4984V6.84543Z",
    fill: "#F75B11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.60208 25.079L0.5 20.3156L20.5333 0.504883L22.9896 2.9339L0.60208 25.079Z",
    fill: "#F75B11"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5546_350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.9942aae17692a0937cb9e537774f283f.svg";
export { ForwardRef as ReactComponent };